var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-app',{staticClass:"layout-auth-sample"})
}
var staticRenderFns = []

export { render, staticRenderFns }